export enum DiscountCategory {
  personalized = 'p_discount',
  minor = 'minor_discount',
  major = 'major_discount',
}
